export const getFilteredGroups = (groups, isOwner) => {
  return groups
    .filter(group => {
      if (isOwner) return group
      return !group?.default
    })
    .map(group => ({
      label: group.name,
      value: group.id,
    }))
}

export const getCurrentUserGroup = (groups, userId) => {
  return groups?.find(group => group?.users?.find(user => user?.id === userId))?.id
}

export const getOtherStoresGroups = (userInfo, storeId) => {
  return userInfo?.stores?.filter(store => store.id !== storeId)?.map(store => store?.group?.id)
}
